import { HomeOutlined } from "@ant-design/icons";
import { Translations, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { HomeView } from "./lazy-view";

const translations: Translations = { de, en };

export const homeViewKey = "app/home";
export const homeViewModule: ViewModule = {
  viewKey: homeViewKey,
  viewEl: <HomeView/>,
  displayNameI18nKey: "app:homeView.title",
  menuIconEl: <HomeOutlined/>,
  translations,
};
